import { mapGetters } from "vuex";

export default {
  name: "CosmoBaseStats",
  data() {
    return {
      currentTimeStep: 0,
    };
  },
  computed: {
    ...mapGetters({
      content: "cosmobase/content"
    })
  },
  mounted() {
    const observer = new IntersectionObserver(
      (entries, observer) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            this.startStepCounter();
            observer.unobserve(entry.target);
          }
        });
      },
      {
        threshold: 0.2,
      },
    );

    if (this.$refs.statsContainer) {
      observer.observe(this.$refs.statsContainer);
    }
  },
  methods: {
    startStepCounter() {
      const interval = setInterval(() => {
        this.currentTimeStep += 1;

        if (this.currentTimeStep > 40) {
          clearInterval(interval);
        }
      }, 50);
    },
    getCurrentNumberCount(limit, step) {
      const number = step * this.currentTimeStep;
      return number > limit ? limit : number;
    },
  },
};
